import Grid from '@material-ui/core/Grid'
import Select from 'Components/Select'
import Upload from 'Components/Upload'
import React from 'react'


export default React.memo(props => <Grid container style={{ margin: 0, padding: 0 }} spacing={0} justify={'center'}
                                         alignItems={'center'}>
    <Grid item xs
          style={{ margin: 0, padding: 5 }}>
      <Select style={props.style} inline={props.inline} title={props.title} options={props.options}
              onChange={props.onChange}
              disabled={props.disabled || false}
              value={props.infoTiers === true && props.data !== undefined ? props.data.id : props.data}/>
    </Grid>
    {props.client_id &&
    <Grid item style={{ margin: 0, padding: 0 }}>
      <Upload disabled={props.disabled || false} media_id={props.data && props.data.valeur_entier} link={props.data && props.data.media_lien}
              client_id={props.client_id} onChange={(r) => props.onChangeInput(r.id, r.media_lien)}/>
    </Grid>}
  </Grid>
)


// WEBPACK FOOTER //
// ./app/Utilitaire/Component/DataComponent/Components/ComboSimpleDocument.js